/**
 * Formats a playback position as m:ss. Mirrors formatElapsed in the loading
 * banner, but takes seconds rather than milliseconds and floors negatives and
 * non-finite input to 0 so a mid-seek value can never render as NaN:NaN.
 *
 * @param {number} seconds - Playback position in seconds
 * @returns {string}
 */
export const formatPlaybackTime = (seconds) => {
  const totalSeconds = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0
  const minutes = Math.floor(totalSeconds / 60)

  return `${minutes}:${String(totalSeconds % 60).padStart(2, '0')}`
}
